import { isGeneratedInteriorDimension, type Dimension } from "building-types/dimensions/dimensionTypes";
import type { AutoDimensionRuntimeHandle } from "building-types/handles/docEntityHandleTypes";
import { interiorDimensionCategoryReplaceMap } from "building-types/views/sheetGeometryCategory";
import { multimapFlatten } from "common/data/multimap";
import { makeDimension } from "doc/dimensions";
import { makeSheetGeometryFromDimensions } from "doc/plans/planDimensions";
import { type PlanGenerationContext, PlanGeometryBuilder } from "doc/plans/planGeometrySource";
import { filterInteriorDimensionsToReportingUnit } from "./interiorDimensionReportingUnitFilter";
import { getReportingUnitRoomIds } from "./reportingUnitRooms";

export function makeSheetGeometryFromInteriorDimensionsByLevel({
  building,
  levelId,
  dimensionPrecision,
  planRotationRads,
  selectedReportingUnitLabelId,
}: PlanGenerationContext) {
  const levelGeneratedDimensions = building?.interiorDimensions[levelId] ?? {};
  let interiorDimensions = multimapFlatten(levelGeneratedDimensions).filter(isGeneratedInteriorDimension);

  // Keep only the interior dimensions anchored entirely within the selected reporting unit.
  const reportingUnitRoomIds = getReportingUnitRoomIds(building, selectedReportingUnitLabelId);
  if (reportingUnitRoomIds) {
    interiorDimensions = filterInteriorDimensionsToReportingUnit(interiorDimensions, building, reportingUnitRoomIds);
  }

  const displayDims: Dimension[] = [];
  interiorDimensions.forEach((dim) =>
    makeDimension(displayDims, {
      ...dim,
      dimensionPrecision,
      handle: dim.docEntityHandle as AutoDimensionRuntimeHandle | undefined,
    }),
  );

  const dimensionPlanGeometries = makeSheetGeometryFromDimensions({
    handle: displayDims.map((dim) => dim.handle),
    interiorDimensionType: building.settings.planset.interiorDimensionType,
    dimensions: displayDims,
    planRotationRads,
  });

  const builder = new PlanGeometryBuilder();
  builder.addAllFrom(dimensionPlanGeometries, interiorDimensionCategoryReplaceMap);
  return builder;
}
